import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PartRequest } from "@vendata/power-up-spec";

export const useUpdatePart = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: PartRequest }) => {
      return handleClientMethod(
        getClient().PUT("/parts/{id}", {
          params: { path: { id } },
          body: data,
        }),
      );
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
      queryClient.invalidateQueries({
        queryKey: ["parts", "get-by-id", data.part.id],
      });
    },
  });
};
